import * as React from "react";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import Render from "source/app/presentation/Shared/Render";

export function CustomOptionsIndicator({ state }: { state: IRootNodeFormState; }) {
    return (
        <Render
            id={`workflowNode_customOptions_Indicator`}
            when={state.newOptions}
            tooltip="this node has custom options"
        >
            <span
                style={{
                    padding: "4px",
                    borderRadius: "4px",
                    margin: "10px",
                    fontSize: "11px",
                    background: "#1e1e1e85",
                    fontWeight: "bold",
                    opacity: 0.5,
                }}
            >
                custom
            </span>
        </Render>
    );
}
